/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_CatalanInputs */



/**
* | output |
* | --- |
* | "Catalan" |
*
* @param {Speechmatics_Target_Language_CatalanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_catalan = /** @type {((inputs?: Speechmatics_Target_Language_CatalanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_CatalanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Catalan")
	if (locale === "de") return /** @type {LocalizedString} */ ("katalanisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("catalano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("каталанский")
	if (locale === "es") return /** @type {LocalizedString} */ ("catalán")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加泰罗尼亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カタルーニャ語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कातालान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("catalão")
	return /** @type {LocalizedString} */ ("Catalan")
});